import { useState } from "react";

export function Kontendetails({ userInstance }) {
    const [search, setSearch] = useState("");
    const [detail, setDetails] = useState({name: '', auth: '', zvs: ''});
    const searching = event => {
        event.preventDefault();
        userInstance.getUserInformationLoginInformationPost(search, (error, data, response) => {
            if (error) {
                if (response) {
                    const why = JSON.parse(response.text);
                    alert(`Fehler aufgetreten. \nCode: ${why.code}\nDetail: ${why.detail}`);
                } else {
                    console.log(error);
                }
            } else {
                setDetails({ name: data.name, auth: data.auth, zvs: data.zvs });
            }
        });
    };
    return (
        <section className="content-active">
            <h3>Kontendetails einsehen</h3>
            <label>Suche nach: <input type="text" placeholder="---Login-Name---" value={search} onChange={e => setSearch(e.target.value)} /></label>
            {search && <button onClick={searching}>Suchen</button>}
            {detail && <section className="details-acc">
                <label>Benutzername: {detail.name}</label>
                <label>Authorisierung: {detail.auth}</label>
                <label>Zugriff auf: {detail.zvs ? `${detail.zvs}` : 'alle Zweckverbände'}</label>
            </section>}
        </section>
    );
}
